import type { ChangeEvent } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Box } from 'app/components/design-system-components'
import { CheckBoxGeneral } from 'app/components/forms/forms'
import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'

const TOOLTIP_ID = 'applicationRentalLedgerRequiredInfo'

export const RENTAL_LEDGER_REQUIRED_LABEL =
  'Require rental ledger before application submit'

export const RENTAL_LEDGER_REQUIRED_TOOLTIP =
  'When enabled, applicants must upload a rental ledger for current or most recent rental history before submitting in supported team application flows.'
export const PREMIER_UPGRADE_TOOLTIP_SUFFIX = 'Available on Premier Plans.'
export const TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX = 'Team admin can update.'

export const getRentalLedgerRequiredTooltipText = ({
  isAccountPremier,
  isUserAdmin,
}: Pick<
  RentalLedgerRequiredSettingProps,
  'isAccountPremier' | 'isUserAdmin'
>) =>
  `${RENTAL_LEDGER_REQUIRED_TOOLTIP} ${
    !isAccountPremier
      ? PREMIER_UPGRADE_TOOLTIP_SUFFIX
      : !isUserAdmin
      ? TEAM_ADMIN_UPDATE_TOOLTIP_SUFFIX
      : ''
  }`.trim()

export interface RentalLedgerRequiredSettingProps {
  isVisible: boolean
  isChecked: boolean
  isUserAdmin: boolean
  isAccountPremier: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const RentalLedgerRequiredSetting = ({
  isVisible,
  isChecked,
  isUserAdmin,
  isAccountPremier,
  onChange,
}: RentalLedgerRequiredSettingProps): JSX.Element | null => {
  if (!isVisible) {
    return null
  }

  const isDisabled = !isUserAdmin || !isAccountPremier
  const tooltipText = getRentalLedgerRequiredTooltipText({
    isAccountPremier,
    isUserAdmin,
  })

  return (
    <>
      <div className="mb15">
        <CheckBoxGeneral
          id={applicationsAttributesIDs.applicationRentalLedgerRequired}
          label={RENTAL_LEDGER_REQUIRED_LABEL}
          onChange={onChange}
          checked={isChecked}
          eventProcessedByComponent
          disabled={isDisabled}
          showDisabledGrey={isDisabled}
          toolTip={
            (
              <div>
                <i
                  className="icon-help-outline fs16 gray-light-color ibm"
                  data-tooltip-content=""
                  data-tooltip-id={TOOLTIP_ID}
                />
              </div>
            ) as unknown as string // CheckBoxGeneral is a JS base component; proper toolTip typing needs changes there first.
          }
        />
      </div>

      <div>
        <ReactTooltip id={TOOLTIP_ID} className="tool-tip-style">
          <Box maxWidth="260px">{tooltipText}</Box>
        </ReactTooltip>
      </div>
    </>
  )
}

export default RentalLedgerRequiredSetting
